// @flow

import './index.less'

import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Cookies from 'js-cookie'

import LoginRegisterPopup from '../user/login-register-popup'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import arrowRight from '~images/arrowRight.png'

import { useTranslation } from 'react-i18next'

import familyIcon from '~images/iconType/white/family_white.svg'
import empregadaIcon from '~images/iconType/white/housekeeper_white.svg'
import PersonalAccident from '~images/iconType/white/personal_accident_white.svg'
import childIcon from '~images/iconType/white/child_white.svg'
import bikeIcon from '~images/iconType/white/bicycle_white.svg'
import casaIcon from '~images/iconType/white/buildings_white.svg'
import saudeIcon from '~images/iconType/white/health_white.svg'
import pprIcon from '~images/iconType/white/ppr_white.svg'
import scooterIcon from '~images/iconType/white/electric_scooter_white.svg'
import viagemIcon from '~images/iconType/white/travel_white.svg'
import droneIcon from '~images/iconType/white/drone_white.svg'
import vidaIcon from '~images/iconType/white/life_white.svg'
import dentalIcon from '~images/iconType/white/dental_white.svg'
import petIcon from '~images/iconType/white/pet_white.svg'
import electroIcon from '~images/iconType/white/electro_white.svg'
import gadgetIcon from '~images/iconType/white/gadget_white.svg'
import mortgageIcon from '~images/iconType/white/mortgage_white.svg'
import criticalIcon from '~images/iconType/white/critical_illness_white.svg'
import hospitalizationIcon from '~images/iconType/white/hospital_white.svg'
import WorkAccidentIcon from '~images/iconType/white/work_accident_white.svg'
import LocalLodgingIcon from '~images/iconType/white/local_lodging_white.svg'
import carroIcon from '~images/iconType/white/car_white.svg'

import PartnersHeader from '~utils/partners-header'
import { HAS_USER_LOGGED_OUT, SET_PATH_TO_REDIRECT } from '../../store/actions'

type PropsType = {
  history: Object
}

function Home({ history }: PropsType) {
  const { t } = useTranslation()
  const token = useSelector((state: any) => state.token)
  const user = useSelector((state: any) => state.user)
  const isAuthenticated = useSelector((state: any) => state.isAuthenticated)
  const hasUserLoggedOut = useSelector((state: any) => state.hasUserLoggedOut)
  const pathname = useSelector((state: any) => state.pathToRedirect)
  const [showLogin, setShowLogin] = useState(false)
  const [redirectTo, setRedirectTo] = useState('')
  const [userInfo, setUserInfo] = useState('')

  const domain = process.env.NODE_ENV === 'development' ? 'localhost' : '.mudey.pt'
  const [firstname] = useState(Cookies.get('MUDEY_name', { domain: domain }) || '')
  const [email] = useState(Cookies.get('MUDEY_email', { domain: domain }) || '')
  const dispatch = useDispatch()

  useEffect(() => {
    if (token !== '') {
      setUserInfo(`?email=${email}`)
    }
  }, [token])

  useEffect(() => {
    if (pathname != null && !isAuthenticated) {
      setShowLogin(true)
    }

    if (isAuthenticated) {
      setShowLogin(false)
    }
  }, [pathname, isAuthenticated])

  const navigateTo = (page: string) => {
    //here we link insurances for an external website (mudey.pt)
    if (page === 'bike') {
      window.location.href = `${process.env.REACT_APP_HP_URL}/produtos/seguro-bicicleta-simulacao${userInfo}`
    } else if (page === 'drone') {
      window.location.href = `https://mudey.pt/produtos/seguro-drones/seguro-drone-simulacao/`
    } else if (page === 'family') {
      window.location.href = `${process.env.REACT_APP_HP_URL}/produtos/seguro-familia/simulador${userInfo}`
    } else if (page === 'scooter') {
      window.location.href = `${process.env.REACT_APP_HP_URL}/produtos/seguro-trotinete/simulador${userInfo}`
    } else if (page === 'child') {
      window.location.href = `${process.env.REACT_APP_HP_URL}/produtos/seguro-crianca/simulador${userInfo}`

      // link to insurances on our website but without login
    } else if (page == 'seguro-garantia') { 
      if (user) {
        history.push(`/seguro-garantia/simulacao/?overview=${user.uuid}`)
      } else {
        history.push(`/seguro-garantia/simulacao`)
      }
    } else if (page === 'seguro-carro') {
      if (user) {
        history.push(`/seguro-carro/simulacao/?overview=${user.uuid}`)
      } else {
        history.push(`/seguro-carro/simulacao`)
      }
    } else if (page === 'seguro-acidentes-trabalho-independente') {
      if (user) {
        history.push(`/seguro-acidentes-trabalho-independente/simulacao/?overview=${user.uuid}`)
      } else {
        history.push(`/seguro-acidentes-trabalho-independente/simulacao`)
      }
    } else if (page === 'seguro-viagem') {
      if (user) {
        history.push(`/seguro-viagem/simulacao/?overview=${user.uuid}`)
      } else {
        history.push(`/seguro-viagem/simulacao`)
      }
    } else if (page === 'doencas-graves') {
      if (user) {
        history.push(`/doencas-graves/simulacao/?overview=${user.uuid}`)
      } else {
        history.push(`/doencas-graves/simulacao`)
      }
    } else if (page === 'hospitalização') {
      if (user) {
        history.push(`/hospitalização/simulacao/?overview=${user.uuid}`)
      } else {
        history.push(`/hospitalização/simulacao`)
      }
    } else if (page === 'seguro-dental') {
      if (user) {
        history.push(`/seguro-dental/simulacao/?overview=${user.uuid}`)
      } else {
        history.push(`/seguro-dental/simulacao`)
      }
    } else if (page === 'seguro-animais') {
      if (user) {
        history.push(`/seguro-animais-domesticos/simulacao/?overview=${user.uuid}`)
      } else {
        history.push(`/seguro-animais-domesticos/simulacao`)
      }
    } else if (page === 'seguro-vida') {
      if (user) {
        history.push(`/seguro-vida/simulacao/?overview=${user.uuid}`)
      } else {
        history.push(`/seguro-vida/simulacao`)
      }
    } else if (page === 'seguro-alojamento-local') {
      if (user) {
        history.push(`/seguro-alojamento-local/simulacao/?overview=${user.uuid}`)
      } else {
        history.push(`/seguro-alojamento-local/simulacao`)
      }
    } else if (page === 'seguro-ppr') {
      if (user) {
        history.push(`/seguro-ppr/simulacao/?overview=${user.uuid}`)
      } else {
        history.push(`/seguro-ppr/simulacao`)
      }
    } else if (page === 'seguro-empregada') {
      if (user) {
        history.push(`/seguro-empregada/simulacao/?overview=${user.uuid}`)
      } else {
        history.push(`/seguro-empregada/simulacao`)
      }
    } else if (page === 'seguro-vida-credito') {
      if (user) {
        history.push(`/seguro-vida-credito/simulacao/?overview=${user.uuid}`)
      } else {
        history.push(`/seguro-vida-credito/simulacao`)
      }
    } else if (page === 'seguro-saude') {
      if (user) {
        history.push(`/seguro-saude/simulacao/?overview=${user.uuid}`)
      } else {
        history.push(`/seguro-saude/simulacao`)
      }
    } else if (page === 'seguro-casa') {
      if (user) {
        history.push(`/seguro-casa/simulacao/?overview=${user.uuid}`)
      } else {
        history.push(`/seguro-casa/simulacao`)
      }
    } else if (token) { // its already loged in 
      history.push(`${page}/simulacao`)
      setShowLogin(false)
    } else { // requires loged in
      setRedirectTo(`${page}/simulacao`)
      setShowLogin(true)
    }
  }

  const componentCleanup = () => {
    dispatch({ type: SET_PATH_TO_REDIRECT, payload: null })
  }

  useEffect(() => {
    dispatch({ type: 'SET_IS_LOADING', payload: false })
    window.addEventListener('beforeunload', componentCleanup)

    return () => {
      dispatch({ type: HAS_USER_LOGGED_OUT, payload: false })
    }
  }, [])

  const style = { background: '#0092ff', padding: '8px 0' }

  const renderInsurance = (
    innactive: boolean,
    icon: string,
    text: string,
    type: string,
    color: 'blue' | 'purple' | 'white' | 'yellow',
    textColor: string
  ) => {
    return (
      <>
        <div
          className="product-content-wrapper"
          onClick={() => {
            dispatch({ type: HAS_USER_LOGGED_OUT, payload: false })
            localStorage.removeItem('pathToRedirect')
            if (!innactive) {
              navigateTo(type)
            }
          }}>
          <div
            className={`product-content  ${!innactive ? 'pop-on-hover' : 'innactive-product'}`}
            style={{ boxShadow: `inset 0px 0px 0px 1px ${color}` }}>
            <div
              className="image-wrapper"
              style={{ backgroundColor: color, width: type == 'seguro-acidentes-trabalho-independente' ? '63px' : '' }}>
              <img src={icon} className="product-img" />
              {!innactive ? (
                <img src={arrowRight} className="product-arrow-icon" />
              ) : (
                <>
                  <span className="coming-soon mobile-version" style={{ display: !innactive ? 'none' : 'block' }}>
                    EM BREVE
                  </span>
                </>
              )}
            </div>
            <div className="text-wrapper">
              <span className="coming-soon desktop-version" style={{ display: !innactive ? 'none' : 'block' }}>
                EM BREVE
              </span>
              <span className="product-text" style={{ color: textColor }}>
                {text}
              </span>
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="home__container">
        <div className="partner-home-wrapper">
          <div className="wrapper-partner-position">
            <PartnersHeader />
          </div>
        </div>
        <p className="home-title">{t('home.title')}</p>
        <div className="main-box">
          <div className="left-sub-section" />
          {/* </div> */}
          <div className="right-sub-section">
            <div className="main-box-col">
              <div className="section-heading">Saúde</div>
              {/* <div className="hr" /> */}

              {renderInsurance(false, saudeIcon, t('home.options.health'), 'seguro-saude', '#59a6a4ff', '#59a6a4ff')}
              {renderInsurance( false, criticalIcon, t('home.options.criticalIllness'), 'doencas-graves', '#59a6a4ff', '#59a6a4ff')}
              {renderInsurance( false, hospitalizationIcon, t('home.options.hospitalization'), 'hospitalização', '#59a6a4ff', '#59a6a4ff')}
              {renderInsurance(false, dentalIcon, t('home.options.dental'), 'seguro-dental', '#59a6a4ff', '#59a6a4ff')}
              {renderInsurance(false, childIcon, t('home.options.child'), 'child', '#59a6a4ff', '#59a6a4ff')}
              {/* {renderInsurance( false, PersonalAccident, t('home.options.personalaccident'), 'seguro-acidentes-pessoais', '#59a6a4ff', '#59a6a4ff')} */}
            </div>
            <div className="main-box-col">
              <div className="section-heading">Casa</div>
              {renderInsurance( false, mortgageIcon, t('home.options.mortgage'), 'seguro-vida-credito', '#986795ff', '#986795ff')}
              {renderInsurance(false, casaIcon, t('home.options.house'), 'seguro-casa', '#986795ff', '#986795ff')}
              {renderInsurance( false, empregadaIcon, t('home.options.housekeeper'), 'seguro-empregada', '#986795ff', '#986795ff')}
              {renderInsurance( false, electroIcon, t('home.options.eletrodomésticos'), 'seguro-garantia', '#986795ff', '#986795ff')}
              {renderInsurance(false, petIcon, t('home.options.pets'), 'seguro-animais', '#986795ff', '#986795ff')}
              {renderInsurance( false, LocalLodgingIcon, t('home.options.localAccomodation'), 'seguro-alojamento-local', '#986795ff', '#986795ff')}
              {renderInsurance(false, familyIcon, t('home.options.family'), 'family', '#986795ff', '#986795ff')}
            </div>
            <div className="main-box-col">
              <div className="section-heading">Viagem e Lazer</div>
              {renderInsurance(false, viagemIcon, t('home.options.trip'), 'seguro-viagem', '#e0af6cff', '#e0af6cff')}
              {renderInsurance(false, bikeIcon, t('home.options.bike'), 'bike', '#e0af6cff', '#e0af6cff')}
              {renderInsurance(false, scooterIcon, t('home.options.scooter'), 'scooter', '#e0af6cff', '#e0af6cff')}
              {renderInsurance( false, gadgetIcon, t('home.options.gadgets'), 'seguro-garantia', '#e0af6cff', '#e0af6cff')}
              {renderInsurance(false, droneIcon, t('home.options.drone'), 'drone', '#e0af6cff', '#e0af6cff')}
            </div>
            <div className="main-box-col">
              <div className="section-heading">Trabalho e Finanças</div>
              {renderInsurance(false, carroIcon, t('home.options.car'), 'seguro-carro', '#59a6a4ff', '#59a6a4ff')}
              {renderInsurance( false, WorkAccidentIcon, t('home.options.workIndependent'), 'seguro-acidentes-trabalho-independente', '#59a6a4ff', '#59a6a4ff')}
              {renderInsurance(false, vidaIcon, t('home.options.life'), 'seguro-vida', '#59a6a4ff', '#59a6a4ff')}
              {renderInsurance(false, pprIcon, t('home.options.ppr'), 'seguro-ppr', '#59a6a4ff', '#59a6a4ff')}
              {/* {renderInsurance(false, pprIcon, t('home.options.kk'), 'seguro-garantia', '#59a6a4ff', '#59a6a4ff')} */}
            </div>
          </div>
        </div>

        {/* {renderInsurance(false, droneIcon, t('home.options.drone'), 'drone', '', '#5e455d')} */}
        {/* <Divider orientation="left" /> */}
        {/* {renderInsurance(true, thirdPartyIcon, t('home.options.thirdParty'), 'seguro-terceiros', 'blue', '#607574')} */}
        {/* {renderInsurance(true, motaIcon, t('home.options.mota'), 'seguro-mota', 'purple', '#5e455d')} */}
        {/* </Row> */}

        <LoginRegisterPopup
          history={history}
          onClose={() => setShowLogin(false)}
          redirectTo={redirectTo}
          show={showLogin}
        />
      </div>
    </>
  )
}

Home.propTypes = {
  history: PropTypes.any.isRequired
}

const mapStateToProps = (state: Object) => {
  return {
    isAuthenticated: state.isAuthenticated,
    user: state.user
  }
}

const mapDispatchToProps = null

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home)
